// src/stores/SceneDataStore.js
import { writable } from 'svelte/store'

export const straitSceneInfo = writable({})
export const sceneProgress = writable(null)
export const currentSceneId = writable(null)
